import { track } from "../track";

export const trackAvatarVideoUploadScs = () =>
  track({ event: "avatar_video_upload_scs" });
